import { fieldTypes, SectionHeader } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import "./ComplexFields.scss";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import { DepositApplicationReadDTO } from "@/types";

export interface InsuredCashSweepOptInComplexValue {
  showHeader?: boolean;
  headerLabel?: string;
  readOnly?: boolean;
}

export interface InsuredCashSweepOptInComplexFieldProps extends fieldTypes.BaseFieldProps<any> {
  formValue?: DepositApplicationReadDTO;
}

export const InsuredCashSweepOptInComplexField: FC<InsuredCashSweepOptInComplexFieldProps> = (
  props
) => {
  const insuredCashSweepOptInComplexValue =
    props.complexFieldValue as InsuredCashSweepOptInComplexValue;
  const readOnly = insuredCashSweepOptInComplexValue?.readOnly || props.readOnly;

  return (
    <section className="complex-field-container insured-cash-sweep-opt-in">
      <SectionHeader label={insuredCashSweepOptInComplexValue?.headerLabel || props.label} hidden={!insuredCashSweepOptInComplexValue?.showHeader} />
      <div className="complex-field-content">
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.INSURED_CASH_SWEEP_OPT_IN.IS_INSURED_CASH_SWEEP_OPT_IN_ENABLED
          }
          complexFieldProps={{
            disabled: readOnly,
          }}
        />
      </div>
    </section>
  );
};
